import React, { FC, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Backdrop, CircularProgress } from "@mui/material";

import { useSelector } from "../../store";
import { useCreateCheckoutSessionMutation } from "../../store/pomeriumApi";
import { buildCancelUrl, buildSuccessUrl } from "./billing-urls";

const Resubscribe: FC = () => {
  const { organizationId } = useSelector((state) => state.current);
  const [createCheckoutSession] = useCreateCheckoutSessionMutation();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const result = await createCheckoutSession({
          organizationId,
          createCheckoutSessionRequest: {
            cancelUrl: buildCancelUrl(searchParams.get("returnUrl")),
            successUrl: buildSuccessUrl(searchParams.get("returnUrl")),
          },
        });
        if ("data" in result && result.data?.url) {
          location.href = result.data.url;
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <Backdrop open={loading}>
        <CircularProgress />
      </Backdrop>
    </>
  );
};

export default Resubscribe;
